export default {
  categories: ["General Stacks"],
  checkpoints: [
    {
      text: "1 - Online public access catalog / คอมพิวเตอร์สืบค้นหนังสือ",
      value: 1
    },
    { text: "2 - Circulation counter / เคาน์เตอร์บริการยืม-คืน", value: 2 },
    { text: "3 - Circulation counter / เคาน์เตอร์บริการยืม-คืน", value: 3 },
    {
      text: "4 - Foreign language general books / หนังสือภาษาอังกฤษ",
      value: 4
    },
    { text: "5 - 2nd  floor stairway / บันไดชั้น 2", value: 5 },
    { text: "6 - 2nd  floor stairway / บันไดชั้น 2", value: 6 },
    {
      text: "7 - Foreign language general books / หนังสือภาษาอังกฤษ",
      value: 7
    },
    {
      text: "8 - Foreign language general books / หนังสือภาษาอังกฤษ",
      value: 8
    },
    { text: "9 - 3rd floor stairway / บันไดชั้น 3", value: 9 },
    { text: "10 - 3rd floor stairway / บันไดชั้น 3", value: 10 },
    { text: "11 - Thai language general books / หนังสือภาษาไทย", value: 11 },
    { text: "12 - Thai language general books / หนังสือภาษาไทย", value: 12 },
    { text: "13 - Reading area / ที่นั่งอ่านหนังสือแบบเดี่ยว", value: 13 }
  ],
  codes: {
    EN42: { category: "General Stacks", first: "", second: "" },
    EN43: { category: "General Stacks", first: "C1", second: "" },
    EN44: { category: "General Stacks", first: "DS590", second: "" },
    EN45: { category: "General Stacks", first: "HB140", second: "" },
    EN46: { category: "General Stacks", first: "HD2700", second: "" },
    EN47: { category: "General Stacks", first: "HF5549.5", second: "Q" },
    EN48: { category: "General Stacks", first: "HM200", second: "" },
    EN49: { category: "General Stacks", first: "HT350", second: "" },
    EN50: { category: "General Stacks", first: "JN6000", second: "" },
    EN51: { category: "General Stacks", first: "KF1430", second: "" },
    EN52: { category: "General Stacks", first: "NA2711", second: "" },
    EN53: { category: "General Stacks", first: "PE1449", second: "" },
    EN54: { category: "General Stacks", first: "QA76.73", second: "R" },
    EN55: { category: "General Stacks", first: "QC21.2", second: "T" },
    EN56: { category: "General Stacks", first: "QD911", second: "" },
    EN57: { category: "General Stacks", first: "SF", second: "" },
    EN58: { category: "General Stacks", first: "TK400", second: "" },
    EN59: { category: "General Stacks", first: "TP375", second: "" },
    EN60: { category: "General Stacks", first: "TX795", second: "" },
    TH1: { category: "General Stacks", first: "", second: "" },
    TH2: { category: "General Stacks", first: "BF698", second: "ศ" },
    TH3: { category: "General Stacks", first: "BQ4570", second: "ก6" },
    TH4: { category: "General Stacks", first: "DH", second: "" },
    TH5: { category: "General Stacks", first: "DS570.3", second: "ส" },
    TH6: { category: "General Stacks", first: "DS580", second: "บ" },
    TH7: { category: "General Stacks", first: "DS735", second: "" },
    TH8: { category: "General Stacks", first: "H", second: "" },
    TH9: { category: "General Stacks", first: "HB180", second: "ภ" },
    TH10: { category: "General Stacks", first: "HD30.28", second: "อ" },
    TH11: { category: "General Stacks", first: "HE", second: "" },
    TH12: { category: "General Stacks", first: "HF5548.8", second: "ก" },
    TH13: { category: "General Stacks", first: "HM100", second: "" },
    TH14: { category: "General Stacks", first: "HT160", second: "ก" },
    TH15: { category: "General Stacks", first: "JA69", second: "ฟ" },
    TH16: { category: "General Stacks", first: "JQ1745", second: "ถ" },
    TH17: { category: "General Stacks", first: "K1150", second: "ก" },
    TH18: { category: "General Stacks", first: "KPT510", second: "ก" },
    TH19: { category: "General Stacks", first: "KPT1400", second: "" },
    TH20: { category: "General Stacks", first: "KPT2764", second: "พ" },
    TH21: { category: "General Stacks", first: "KPT4610", second: "ธ638" },
    TH22: { category: "General Stacks", first: "LC221", second: "" },
    TH23: { category: "General Stacks", first: "NC", second: "" },
    TH24: { category: "General Stacks", first: "PE1131", second: "ม" },
    TH25: { category: "General Stacks", first: "PL2600", second: "" },
    TH26: { category: "General Stacks", first: "PL4209.1", second: "ฟ" },
    TH27: { category: "General Stacks", first: "QA76.2", second: "ฉ" },
    TH28: { category: "General Stacks", first: "QC320", second: "ม" },
    TH29: { category: "General Stacks", first: "S471", second: "" },
    TH30: { category: "General Stacks", first: "T385", second: "อ4" },
    TH31: { category: "General Stacks", first: "TH6561", second: "" },
    TH32: { category: "General Stacks", first: "TP318", second: "พ94" },
    TH33: { category: "General Stacks", first: "TX773", second: "ม6" }
  },
  floors: ["2", "3"],
  name: "Puey Ungphakorn Library, Rangsit Campus",
  nodes: {
    CP1: { floor: "2", from: ["CP2"], x: 504, y: 278 },
    CP2: { floor: "2", from: ["CP1", "CP3", "CP5"], x: 304, y: 391 },
    CP3: { floor: "2", from: ["CP2", "CP4"], x: 185, y: 458 },
    CP4: { floor: "2", from: ["CP3"], x: 185, y: 821 },
    CP5: { floor: "2", from: ["CP2", "CP6", "CP7"], x: 304, y: 641 },
    CP6: { floor: "2", from: ["CP5", "CP9"], x: 347, y: 641 },
    CP7: { floor: "2", from: ["CP5", "CP8"], x: 304, y: 956 },
    CP8: { floor: "2", from: ["CP7"], x: 706, y: 956 },
    CP9: { floor: "3", from: ["CP6", "CP10"], x: 313, y: 192 },
    CP10: { floor: "3", from: ["CP9", "CP11", "CP13"], x: 268, y: 113 },
    CP11: { floor: "3", from: ["CP10", "CP12"], x: 268, y: 696 },
    CP12: { floor: "3", from: ["CP11", "CP13"], x: 678, y: 696 },
    CP13: { floor: "3", from: ["CP12", "CP10"], x: 678, y: 113 },
    EN42: { floor: "2", from: ["CP8"], x: 706, y: 767 },
    EN43: { floor: "2", from: ["CP8"], x: 706, y: 799 },
    EN44: { floor: "2", from: ["CP8"], x: 706, y: 831 },
    EN53: { floor: "2", from: ["CP7", "CP8"], x: 322, y: 956 },
    EN52: { floor: "2", from: ["CP7", "CP8"], x: 368, y: 956 },
    EN51: { floor: "2", from: ["CP7", "CP8"], x: 413, y: 956 },
    EN50: { floor: "2", from: ["CP7", "CP8"], x: 459, y: 956 },
    EN49: { floor: "2", from: ["CP7", "CP8"], x: 504, y: 956 },
    EN48: { floor: "2", from: ["CP7", "CP8"], x: 550, y: 956 },
    EN47: { floor: "2", from: ["CP7", "CP8"], x: 595, y: 956 },
    EN46: { floor: "2", from: ["CP7", "CP8"], x: 641, y: 956 },
    EN45: { floor: "2", from: ["CP7", "CP8"], x: 686, y: 956 },
    // EN66: { floor: "2", from: ["CP2", "CP5", "CP7"], x: 304, y: 450 },
    // EN65: { floor: "2", from: ["CP2", "CP5", "CP7"], x: 304, y: 482 },
    // EN64: { floor: "2", from: ["CP2", "CP5", "CP7"], x: 304, y: 514 },
    // EN63: { floor: "2", from: ["CP2", "CP5", "CP7"], x: 304, y: 545 },
    // EN62: { floor: "2", from: ["CP2", "CP5", "CP7"], x: 304, y: 577 },
    // EN61: { floor: "2", from: ["CP2", "CP5", "CP7"], x: 304, y: 609 },
    EN60: { floor: "2", from: ["CP2", "CP5", "CP7"], x: 304, y: 641 },
    EN59: { floor: "2", from: ["CP2", "CP5", "CP7"], x: 304, y: 672 },
    EN58: { floor: "2", from: ["CP2", "CP5", "CP7"], x: 304, y: 704 },
    EN57: { floor: "2", from: ["CP2", "CP5", "CP7"], x: 304, y: 736 },
    EN56: { floor: "2", from: ["CP2", "CP5", "CP7"], x: 304, y: 768 },
    EN55: { floor: "2", from: ["CP2", "CP5", "CP7"], x: 304, y: 799 },
    EN54: { floor: "2", from: ["CP2", "CP5", "CP7"], x: 304, y: 831 },
    TH13: { floor: "3", from: ["CP12", "CP13"], x: 678, y: 671 },
    TH12: { floor: "3", from: ["CP12", "CP13"], x: 678, y: 635 },
    TH11: { floor: "3", from: ["CP12", "CP13"], x: 678, y: 600 },
    TH10: { floor: "3", from: ["CP12", "CP13"], x: 678, y: 564 },
    TH9: { floor: "3", from: ["CP12", "CP13"], x: 678, y: 529 },
    TH8: { floor: "3", from: ["CP12", "CP13"], x: 678, y: 493 },
    TH7: { floor: "3", from: ["CP12", "CP13"], x: 678, y: 458 },
    TH6: { floor: "3", from: ["CP12", "CP13"], x: 678, y: 422 },
    TH5: { floor: "3", from: ["CP12", "CP13"], x: 678, y: 386 },
    TH4: { floor: "3", from: ["CP12", "CP13"], x: 678, y: 351 },
    TH3: { floor: "3", from: ["CP12", "CP13"], x: 678, y: 315 },
    TH2: { floor: "3", from: ["CP12", "CP13"], x: 678, y: 280 },
    TH1: { floor: "3", from: ["CP12", "CP13"], x: 678, y: 244 },
    TH22: { floor: "3", from: ["CP11", "CP12"], x: 311, y: 696 },
    TH21: { floor: "3", from: ["CP11", "CP12"], x: 352, y: 696 },
    TH20: { floor: "3", from: ["CP11", "CP12"], x: 392, y: 696 },
    TH19: { floor: "3", from: ["CP11", "CP12"], x: 433, y: 696 },
    TH18: { floor: "3", from: ["CP11", "CP12"], x: 473, y: 696 },
    TH17: { floor: "3", from: ["CP11", "CP12"], x: 514, y: 696 },
    TH16: { floor: "3", from: ["CP11", "CP12"], x: 554, y: 696 },
    TH15: { floor: "3", from: ["CP11", "CP12"], x: 595, y: 696 },
    TH14: { floor: "3", from: ["CP11", "CP12"], x: 635, y: 696 },
    TH23: { floor: "3", from: ["CP10", "CP11"], x: 268, y: 678 },
    TH24: { floor: "3", from: ["CP10", "CP11"], x: 268, y: 638 },
    TH25: { floor: "3", from: ["CP10", "CP11"], x: 268, y: 597 },
    TH26: { floor: "3", from: ["CP10", "CP11"], x: 268, y: 557 },
    TH27: { floor: "3", from: ["CP10", "CP11"], x: 268, y: 516 },
    TH28: { floor: "3", from: ["CP10", "CP11"], x: 268, y: 476 },
    TH29: { floor: "3", from: ["CP10", "CP11"], x: 268, y: 435 },
    TH30: { floor: "3", from: ["CP10", "CP11"], x: 268, y: 395 },
    TH31: { floor: "3", from: ["CP10", "CP11"], x: 268, y: 354 },
    TH32: { floor: "3", from: ["CP10", "CP11"], x: 268, y: 314 },
    TH33: { floor: "3", from: ["CP10", "CP11"], x: 268, y: 273 }
  },
  patterns: {
    EN: [
      /^(?=.*[0-9])[A-Z.0-9]*$/,
      /^(?=[A-Z.0-9]*$)(?=.*[A-Z]|.*19[0-9]{2}|.*20[0-9]{2})/,
      /^[A-Za-z.0-9-]*$/
    ],
    TH: [
      /^(?=.*[0-9])[A-Zก-๛.0-9]*$/,
      /^(?=[A-Zก-๛.0-9]+$)(?=.*[ก-๛]|.*25[0-9]{2})/,
      /^[A-Zก-๛.0-9-]*$/
    ]
  },
  slug: "puey"
};
